import { connect } from 'react-redux';
import {
    setTableFilter,
    selectTableFilterStatus
} from 'src/modules/Tables';

const mapDispatchToProps = {
    setTableFilter
};

const mapStateToProps = (state) => ({
    filterStatus: selectTableFilterStatus(state)
});

export default connect(mapStateToProps, mapDispatchToProps);
